import { transformObjectKeys } from '@/services/errorService';
import merge from 'lodash/merge';

export default {
    data() {
        return {
            backendValidations: { form: {} },
        };
    },
    validations() {
        const base = this.formValidations || {};
        return merge({}, base, this.backendValidations);
    },
    methods: {
        getValueByNestedPath(obj, path) {
            return path.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
        },
        validateFields(fields, form, currentValidationNode = this.backendValidations.form, path = []) {
            Object.keys(fields).forEach(key => {
                const field = fields[key];
                const newPath = [...path, key]; // Aktualna ścieżka jako tablica

                if (typeof field === 'object' && field.message === undefined) {
                    // Jeśli pole jest zagnieżdżonym obiektem, rekurencyjnie przetwarzamy
                    if (!currentValidationNode[key]) {
                        this.$set(currentValidationNode, key, {}); // Tworzymy nowy obiekt na danym poziomie
                    }
                    this.validateFields(field, form, currentValidationNode[key], newPath);
                } else {
                    // Obsługa standardowego pola z komunikatem i parametrami
                    const msg = this.$t(field.message, transformObjectKeys(field.parameters || []));
                    const fieldWrongValue = JSON.stringify(this.getValueByNestedPath(form, newPath));

                    this.$set(currentValidationNode, key, {
                        [msg]: val => {
                            const fieldCurrentValue = JSON.stringify(val);
                            return fieldCurrentValue !== fieldWrongValue; // Bezpośrednie zwrócenie porównania
                        },
                    });
                }
            });

            this.$v.$touch();
        },
        handleBackendValidations(error) {
            const fields = error?.error?.response?.data?.fields;
            if (!fields || (Array.isArray(fields) && !fields.length)) {
                if (error.messages?.length) {
                    this.$toastr.error(error.messages, error.message);
                } else {
                    this.$toastr.error(error.message, this.$t('errorOccurred'));
                }
            } else {
                this.validateFields(fields, this.form);
            }
        },
    },
};
